import * as React from "react";
// import GA4 from "react-ga4";
import YouTube, { YouTubeProps } from "react-youtube";
// const ReactGA = GA4;

declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady: (() => void) | undefined;
  }
}

export interface YoutubeProps {
  videoId: string;
  shouldtrack?: boolean;
  GAEventID?: string;
  GAEventValue?: string;
}

const YouTubeVideo: React.FC<YoutubeProps> = ({
  videoId,
  shouldtrack,
  GAEventID,
  GAEventValue,
}) => {
  const onPlayerReady: YouTubeProps["onReady"] = (event) => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  };

  const opts: YouTubeProps["opts"] = {
    height: "auto",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };

  return <YouTube videoId={videoId} opts={opts} onReady={onPlayerReady} />;
};
export default YouTubeVideo;
